module.exports = __webpack_public_path__ + "static/media/lucky ji_page-0001.290d85a3.jpg";